var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPurpleHex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 121,
    viewBox: "0 0 114 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.9443 118.972C64.2234 121.621 72.3695 120.048 78.1387 114.879L106.245 89.6969C111.743 84.7714 114.25 77.3213 112.851 70.074L105.236 30.646C103.836 23.3986 98.7345 17.4183 91.7982 14.8942L56.3362 1.98951C49.0571 -0.659338 40.911 0.913951 35.1418 6.08284L7.03546 31.2646C1.53796 36.1901 -0.970008 43.6401 0.429684 50.8874L8.04452 90.3155C9.44421 97.5628 14.546 103.543 21.4823 106.067L56.9443 118.972Z",
    fill: "#9A4798"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleHex);
export default __webpack_public_path__ + "static/media/PurpleHex.2709809c0b3971529bd85b238a6cf1ed.svg";
export { ForwardRef as ReactComponent };